import styled from 'styled-components';
import { Star } from '@magalu/stereo-ui-icons';
import { getTextColor } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
export const Line = styled.li`
  display: flex;
  align-items: center;
  column-gap: ${({
  columnGap
}) => columnGap || '8'}px;
`;
export const Score = styled(Text)``;
export const Count = styled(Text)`
  color: ${({
  color
}) => getTextColor(color || 'light')};
`;
export const StarIcon = styled(Star)`
  margin-bottom: 1px;
`;